import { mapToCanActivate, Routes } from '@angular/router';
import { CheckoutGuard } from '../../dashboard/requests/checkout/checkout.guard';
import { permissionGuard } from '../../apeco-services/shared/gurads/permissions.guard';
import { ConfigService } from '../config/config.service';
import { notParentGuard } from '../guards/not-parent.guard';

export function getDashboardRoutes(config: ConfigService): Routes {
  return [
    {
      path: 'profile',
      loadComponent: () =>
        import('../../dashboard/user-profile/user-profile.component').then(
          (m) => m.UserProfileComponent
        )
    },
    {
      path: 'requests',
      loadComponent: () =>
        import('../../dashboard/requests/requests.component').then(
          (m) => m.RequestsComponent
        )
    },
    {
      path: 'workspace',
      loadComponent: () =>
        import('../../dashboard/workspace/workspace.component').then(
          (m) => m.WorkspaceComponent
        )
    },
    {
      path: 'penalties',
      loadComponent: () =>
        import('../../dashboard/penalties/penalties.component').then(
          (m) => m.PenaltiesComponent
        ),
      canActivate: [notParentGuard]
    },
    {
      path: 'services',
      loadChildren: () =>
        import('../../apeco-services/apeco-services.module').then(
          (m) => m.ApecoServicesModule
        )
    },
    {
      path: 'divisions',
      loadChildren: () =>
        import('../../divisions/divisions.module').then(
          (m) => m.DivisionsModule
        ),
      canMatch: [permissionGuard, notParentGuard],
      data: { permission: config.permissions.view_divisions }
    },
    {
      path: 'settings',
      loadChildren: () =>
        import('../../settings/settings.module').then((m) => m.SettingsModule),
      canMatch: [permissionGuard, notParentGuard],
      data: { permission: config.permissions.settings_menu_item }
    },
    {
      path: 'request-details/:id',
      loadComponent: () =>
        import(
          '../../dashboard/request-details/request-details.component'
        ).then((m) => m.RequestDetailsComponent)
    },
    {
      path: 'checkout/:id',
      canActivate: mapToCanActivate([CheckoutGuard]),
      loadComponent: () =>
        import('../../dashboard/requests/checkout/checkout.component').then(
          (m) => m.CheckoutComponent
        )
    },
    {
      path: 'payment-result/:paymentId',
      loadComponent: () =>
        import(
          '../../apeco-services/shared/components/payment-result/payment-result.component'
        ).then((m) => m.PaymentResultComponent)
    },
    {
      path: 'school-details/:id',
      loadComponent: () =>
        import('../../dashboard/school-details/school-details.component').then(
          (m) => m.SchoolDetailsComponent
        )
    },
    {
      path: 'schools',
      loadComponent: () =>
        import('../../dashboard/school-list/school-list.component').then(
          (m) => m.SchoolListComponent
        ),
      canActivate: [notParentGuard]
    },
    {
      path: 'student-list',
      loadComponent: () =>
        import('../../apeco-services/student-list/student-list.component').then(
          (m) => m.StudentListComponent
        ),
      canMatch: [permissionGuard, notParentGuard],
      data: { permission: config.permissions.students_view }
    },
    {
      path: 'invoices',
      loadComponent: () =>
        import('../../dashboard/invoices/invoices.component').then(
          (m) => m.InvoicesComponent
        )
    },
    {
      path: 'documents',
      loadComponent: () =>
        import('../../dashboard/documents/documents.component').then(
          (m) => m.DocumentsComponent
        )
    },
    {
      path: 'outputs',
      loadComponent: () =>
        import('../../dashboard/outputs/outputs.component').then(
          (m) => m.OutputsComponent
        )
    },
    {
      path: 'uploaded-files',
      loadComponent: () =>
        import('../../dashboard/uploaded-files/uploaded-files.component').then(
          (m) => m.UploadedFilesComponent
        )
    },
    {
      path: 'uploaded-files/:id',
      loadComponent: () =>
        import('../../dashboard/uploaded-files/uploaded-files.component').then(
          (m) => m.UploadedFilesComponent
        )
    },
    {
      path: 'notifications',
      loadComponent: () =>
        import('../../dashboard/notifications/notifications.component').then(
          (m) => m.NotificationsComponent
        )
    },
    { path: '', redirectTo: 'workspace', pathMatch: 'full' }
  ];
}
